import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import { Container, } from 'react-bootstrap';

import { Link , useLocation, Navigate, useNavigate} from 'react-router-dom';

import logo from '../Images/logo-white.png'
import ContactUs from './ContactUs'

const Footer = () => {

  const { pathname } = useLocation();
  const navigate    = useNavigate();

  const [data, setData]  = useState({
    email   : 'info@krayrpol.pl',
    contacts : [
      '+48 579 218 740',
    ]
  })
  useEffect(() => {
    setFooterData();
  }, [navigate]);

  // Methods
  const setFooterData = async () => {
    if(pathname === '/academy'){
      setData({
        email : 'krayr.academy@gmail.com',
        contacts : [
          '+48 792 650 587',
        ]
      });

    } else if(pathname === '/careerinpoland'){

      setData({
        email : 'krayr.consultant@krayrpol.pl',
        contacts : [
          '+48 792 650 587',
        ]
      })

    } else if(pathname === '/recruitment'){

      setData({
        email : 'kadry@krayrpol.pl',
        contacts : [
          '+48 608 324 918',
          '+48 739 644 037',
        ]
      })

    } else {
      setData({
        email   : 'info@krayrpol.pl',
          contacts : [
            '+48 579 218 740',
        ]
      })
    }
  }


  return (
    <div>
      <Container>
            
        <div className='row text-white footer-items m-0 p-0 mt-5 '>

            <div className='col-lg-4 col-md-6 col-12 mt-5 '>
                <img src={logo} alt='Logo' className='myLogo py-2 m-0'/>
                <div className='mt-3 '>
                  <div className='d-flex mb-2'>
                    <i className='bi bi-envelope text-white'></i>
                    <span className='mx-3'>
                      { data?.email }
                    </span>

                  </div>
                  <div className='d-flex flex-column'>
                    { data?.contacts?.map((phone, index) => (
                      <div
                        key={index}
                        className="d-flex mb-2">
                        <i className='bi bi-telephone text-white'></i>
                        <span className='mx-3'>
                          { phone }
                        </span>
                      </div>
                    )) }

                  </div>
                </div>
            </div>

            <div className='col-lg-2 col-md-6 col-12 mt-5'>
                <h6 className='mb-3 footer-h6'>For You</h6>
                
                <ul className='m-0 p-0'>
                  <li className='mb-2'><Link to="/academy" className='text-white'>Academy</Link></li>
                  <li className='mb-2'><Link to="/careerinpoland" className='text-white'>Study Abroad</Link></li>
                  <li className='mb-2'><Link to="/careerinpoland" className='text-white'>Career in Poland</Link></li>
                  <li className='mb-2'><Link to="/careerinpoland" className='text-white'>Platform (login) </Link></li>
                </ul>
            </div>
      

  

            <div className='col-lg-2 col-md-6 col-123 mt-5'>
              <h6 className='mb-3 footer-h6'>About</h6>
                <ul className='m-0 p-0'>
                  <li className='mb-2'><Link to="/about-us" className='text-white'>Company</Link></li>
                  <li className='mb-2'><Link to="/#" className='text-white'>Career</Link></li>
                  <li className='mb-2'><Link to="/contact" className='text-white'>Contact Us</Link></li>

                  {/* <ContactUs position="bottom"></ContactUs> */}
                </ul>
            </div>
            <div className='col-lg-2 col-md-6 col-12 mt-5'>
                <h6 className='mb-3 footer-h6'>Address</h6>
                <ul className='m-0 p-0'>
                  <li className='mb-2'>al.Solidarności </li>
                  <li className='mb-2'>168/121 00-240 Warszawa</li>
                </ul>
         
            </div>
            <div className='col-lg-2 col-md-6 col-12 mt-5 '>
              <h6 className='mb-3 footer-h6'>Find Us On</h6>
              <div className='d-flex'>
                 <Link to="/#" className='text-white px-2'><i className="bi bi-instagram fa-lg"></i></Link> 
                 <Link to="/#" className='text-white px-2'><i className='bi bi-facebook fa-lg'></i></Link> 
              </div>
              
            </div>
        </div>

        <div className='mt-4 d-flex flex-column justify-content-center align-items-center'>
          <div className='m-0 p-0 my-2 text-xs text-white align-items-center'>&copy; <span className="mx-1">Krayr</span> 2022</div>
        </div> 

      </Container>
    </div>
  )
}

export default Footer;